import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import { useTranslations } from '../../context/TranslationContext';

// Status values shared by Avatar and AvatarStatus — import these instead of
// hardcoding the strings.
export const AVATAR_STATUS = {
    ONLINE: 'online',
    TALENT_GEM: 'talent-gem',
    ANONYMOUS: 'anonymous',
};

// Small status indicator overlaid on the bottom-right of an Avatar.
//   AVATAR_STATUS.ONLINE     -> solid green dot
//   AVATAR_STATUS.TALENT_GEM -> gem (diamond) glyph
// Anonymous is not a corner badge — Avatar renders it as a full incognito glyph.
// Pass `tooltip` (already translated) to explain the status on hover.
const AvatarStatus = ({ status = null, tooltip = null }) => {
    const { t } = useTranslations();

    let badge = null;
    if (status === AVATAR_STATUS.TALENT_GEM) {
        badge = (
            <span className="avatar-status avatar-status--gem" aria-label={t('Talent gem')}>
                <Icon value="talent-community" noMargin />
            </span>
        );
    } else if (status === AVATAR_STATUS.ONLINE) {
        badge = <span className="avatar-status avatar-status--online" aria-label={t('Online')} />;
    }

    if (!badge) return null;
    if (!tooltip) return badge;
    return <Tooltip title={tooltip}>{badge}</Tooltip>;
};

AvatarStatus.propTypes = {
    status: PropTypes.oneOf([AVATAR_STATUS.ONLINE, AVATAR_STATUS.TALENT_GEM]),
    tooltip: PropTypes.string,
};

export default AvatarStatus;
